"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Switch", {
    enumerable: true,
    get: function() {
        return Switch;
    }
});
var _themetools = require("@chakra-ui/theme-tools");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var parts = (0, _themetools.anatomy)("switch").parts("container", "track", "thumb", "label");
var $width = (0, _themetools.cssVar)("switch-track-width");
var $height = (0, _themetools.cssVar)("switch-track-height");
var _obj, _obj1, _obj2;
var styleBySize = {
    s: {
        container: (_obj = {}, _define_property(_obj, $width.variable, "1.625rem"), _define_property(_obj, $height.variable, "1rem"), _obj),
        label: {
            textStyle: "text-body-meta-regular"
        },
        thumb: {
            width: "0.75rem",
            height: "0.75rem"
        }
    },
    m: {
        container: (_obj1 = {}, _define_property(_obj1, $width.variable, "2.125rem"), _define_property(_obj1, $height.variable, "1.25rem"), _obj1),
        label: {
            textStyle: "text-body-regular"
        },
        thumb: {
            width: "1rem",
            height: "1rem"
        }
    },
    l: {
        container: (_obj2 = {}, _define_property(_obj2, $width.variable, "3.125rem"), _define_property(_obj2, $height.variable, "1.75rem"), _obj2),
        label: {
            textStyle: "text-body-large-regular"
        },
        thumb: {
            width: "1.5rem",
            height: "1.5rem"
        }
    }
};
var getSizeStyleFunction = function(size) {
    return function(props) {
        return _object_spread_props(_object_spread({}, styleBySize[size]), {
            label: _object_spread_props(_object_spread({}, props.theme.textStyles[styleBySize[size].label.textStyle]), {
                color: props.isDisabled ? "text-disabled" : "text-primary"
            })
        });
    };
};
var sizes = {
    s: getSizeStyleFunction("s"),
    m: getSizeStyleFunction("m"),
    l: getSizeStyleFunction("l")
};
var baseStyleTrack = function() {
    return {
        p: "0",
        bg: "background-action-active",
        alignItems: "center",
        _focus: {
            boxShadow: "0 0 0 0.1875rem var(--chakra-colors-primary-focus)"
        },
        _disabled: {
            opacity: 1,
            bgColor: "background-action-disabled"
        },
        _checked: {
            _disabled: {
                bg: "background-action-disabled"
            },
            bg: "primary-default"
        }
    };
};
var baseStyle = function(props) {
    return {
        track: baseStyleTrack(props),
        thumb: {
            marginLeft: "0.125rem"
        },
        label: {
            margin: 0
        }
    };
};
var defaultProps = {
    size: "m"
};
var Switch = {
    parts: parts.keys,
    baseStyle: baseStyle,
    sizes: sizes,
    defaultProps: defaultProps
};
